import { useQuery } from '@tanstack/react-query'
import { webApi } from '@/services/webApi'
import { CITIES } from '@/lib/site'
import type { ApiCity } from '@/types/api'

const FALLBACK_CITIES: ApiCity[] = CITIES.map((city) => ({
  id: city.id,
  name: city.name,
  slug: city.slug,
  image: null,
  propertyCount: 0,
}))

function formatCityName(name: string) {
  if (!name) return name
  return name.replace(/-/g, ' ').replace(/\b\w/g, (c) => c.toUpperCase())
}

export interface UseCitiesOptions {
  /** Filter cities to a state (post-property form). */
  stateId?: number
  /** Header: only cities that have at least one active listing. */
  withListings?: boolean
}

export function useCities(options: UseCitiesOptions = {}) {
  const { stateId, withListings = false } = options

  const query = useQuery({
    queryKey: ['web', 'cities', stateId ?? 'all', withListings ? 'listed' : 'all'],
    queryFn: () => webApi.cities({ stateId, withListings }),
    staleTime: 10 * 60_000,
  })

  const cities = (query.data?.length ? query.data : withListings ? [] : FALLBACK_CITIES).map((city) => ({
    ...city,
    name: formatCityName(city.name),
  }))

  return { ...query, cities }
}
